module.exports = __webpack_public_path__ + "img/cloud_academy.5167cb60.png";